import Link from "next/link";

const CheckGreen = () => (
  <svg className="shrink-0 w-6 h-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.9984 21.5984C17.2968 21.5984 21.5984 17.2968 21.5984 11.9984C21.5984 6.70005 17.2968 2.39844 11.9984 2.39844C6.70005 2.39844 2.39844 6.70005 2.39844 11.9984C2.39844 17.2968 6.70005 21.5984 11.9984 21.5984V21.5984M16.4468 10.4468C16.9016 9.97598 16.8951 9.22754 16.4322 8.76466C15.9693 8.30178 15.2209 8.29527 14.75 8.75004L10.7984 12.7016L9.24684 11.15C8.77598 10.6953 8.02754 10.7018 7.56466 11.1647C7.10177 11.6275 7.09527 12.376 7.55004 12.8468L9.95004 15.2468C10.4186 15.7153 11.1782 15.7153 11.6468 15.2468L16.4468 10.4468V10.4468" fill="#16A34A" />
  </svg>
);

const CheckLight = () => (
  <svg className="shrink-0 w-6 h-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.9984 21.5984C17.2968 21.5984 21.5984 17.2968 21.5984 11.9984C21.5984 6.70005 17.2968 2.39844 11.9984 2.39844C6.70005 2.39844 2.39844 6.70005 2.39844 11.9984C2.39844 17.2968 6.70005 21.5984 11.9984 21.5984V21.5984M16.4468 10.4468C16.9016 9.97598 16.8951 9.22754 16.4322 8.76466C15.9693 8.30178 15.2209 8.29527 14.75 8.75004L10.7984 12.7016L9.24684 11.15C8.77598 10.6953 8.02754 10.7018 7.56466 11.1647C7.10177 11.6275 7.09527 12.376 7.55004 12.8468L9.95004 15.2468C10.4186 15.7153 11.1782 15.7153 11.6468 15.2468L16.4468 10.4468V10.4468" fill="#86EFAC" />
  </svg>
);

export default function PricingSection() {
  return (
    <section className="bg-white py-24 px-5 md:px-20">
      <div className="max-w-7xl mx-auto px-0 md:px-8 flex flex-col gap-16">
        {/* Header */}
        <div className="flex flex-col gap-4 items-center justify-center">
          <div className="bg-white rounded-full border border-[#bae6fd] pt-2 pr-4 pb-2 pl-4 shadow-sm">
            <span
              className="text-[#0369a1] font-bold text-xs leading-4 uppercase"
              style={{ letterSpacing: "0.6px" }}
            >
              pricing
            </span>
          </div>
          <h2 className="text-[#111827] text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold max-w-4xl">
            Flexible Pricing That Scales With You
          </h2>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto w-full">
          {/* Self-Hosted */}
          <div className="bg-white rounded-3xl border-2 border-[#e5e7eb] p-10 flex flex-col gap-6 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]">
            <div className="flex flex-row gap-3 items-center">
              <div className="bg-[#f3f4f6] rounded-3xl flex items-center justify-center w-12 h-12 shrink-0">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M5 12C3.89617 12 3 11.1038 3 10V6C3 4.89617 3.89617 4 5 4H19C20.1038 4 21 4.89617 21 6V10C21 11.1038 20.1038 12 19 12M5 12C3.89617 12 3 12.8962 3 14V18C3 19.1038 3.89617 20 5 20H19C20.1038 20 21 19.1038 21 18V14C21 12.8962 20.1038 12 19 12M17 8H17.01M17 16H17.01" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="text-[#111827] font-['SpaceGrotesk-Bold',_sans-serif] text-2xl leading-8 font-bold">
                Self-Hosted
              </h3>
            </div>

            <p className="text-[#4b5563] font-normal text-lg leading-7">
              Deploy on your infrastructure. Pay only for SMS, telephony, and payment gateway usage.
            </p>

            <ul className="flex flex-col gap-4 py-2">
              {[
                
                "Deploy on your servers",
                "No vendor lock-in",
                "Pay-as-you-go for services",
              ].map((item) => (
                <li key={item} className="flex flex-row gap-3 items-start">
                  <div className="pt-0.5 shrink-0">
                    <CheckGreen />
                  </div>
                  <span className="text-[#374151] font-normal text-base leading-6">{item}</span>
                </li>
              ))}
            </ul>

            <Link href="/contact?ref=debtpulse-price" className="mt-auto bg-[#3b82f6] rounded-lg pt-4 pr-6 pb-4 pl-6 w-full shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)] block text-white text-center font-semibold text-base leading-6">
              Request Pricing
            </Link>
          </div>

          {/* Managed SaaS */}
          <div
            className="rounded-3xl pt-16 p-10 flex flex-col gap-6 shadow-[0px_12px_40px_0px_rgba(0,0,0,0.18)]"
            style={{
              background:
                "linear-gradient(135deg, rgba(15,23,42,1) 0%, rgba(37,99,235,1) 100%)",
              position: "relative",
            }}
          >
            {/* Most Popular badge */}
            <div
              className="bg-white/20 rounded-full pt-1.5 pr-4 pb-1.5 pl-4 absolute top-6 right-6"
              style={{ backdropFilter: "blur(2px)" }}
            >
              <span className="text-white font-semibold text-sm leading-5">Most Popular</span>
            </div>

            <div className="flex flex-row gap-3 items-center">
              <div className="bg-white/20 rounded-3xl flex items-center justify-center w-12 h-12 shrink-0">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 14.9981C3 17.2058 4.79234 18.9981 7 18.9981H16C17.7982 18.9981 19.458 18.0325 20.3467 16.4692C21.2354 14.9059 21.2162 12.9858 20.2964 11.4406C19.3766 9.89541 17.6979 8.96316 15.9 8.99912C15.5554 7.22183 14.2773 5.76947 12.5582 5.20168C10.8392 4.6339 8.94746 5.03931 7.61207 6.26172C6.27667 7.48412 5.70602 9.33269 6.12 11.0951C4.29558 11.507 2.99991 13.1278 3 14.9981H3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="text-white font-['SpaceGrotesk-Bold',_sans-serif] text-2xl leading-8 font-bold">
                Managed SaaS
              </h3>
            </div>

            <p className="text-[#f3e8ff] font-normal text-lg leading-7">
              Tiered pricing based on portfolio size. No hidden per-borrower fees.
            </p>

            <ul className="flex flex-col gap-4 py-2">
              {[
                "Fully managed infrastructure",
                "24/7 support & monitoring",
                "Automatic updates & backups",
                "Transparent tiered pricing",
              ].map((item) => (
                <li key={item} className="flex flex-row gap-3 items-start">
                  <div className="pt-0.5 shrink-0">
                    <CheckLight />
                  </div>
                  <span className="text-[#f3e8ff] font-normal text-base leading-6">{item}</span>
                </li>
              ))}
            </ul>

            <Link href="/contact?ref=debtpulse-price" className="mt-auto bg-white rounded-lg pt-4 pr-6 pb-4 pl-6 w-full shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)] block text-[#111827] text-center font-semibold text-base leading-6">
              Request Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
